/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */



(function($) {

window.initMap = function() {
	// Google Map
	// var lat = '52.5742805';
	// var long = '-0.2431467';
	var locations = [
		['Grasmere Stamford', 52.6529329, -0.4767093, 1],
		['Grasmere Market Deeping', 52.6752883, -0.3179853, 1],
		['Grasmere Bourne', 52.768013, -0.3778344, 1],
	];


	if ($('#map-canvas').length > 0) {
		var isDraggable = $(document).width() > 768 ? true : false;
		var styles = [{"featureType":"all","elementType":"geometry","stylers":[{"gamma":"0.82"}]},{"featureType":"all","elementType":"geometry.fill","stylers":[{"gamma":"1.21"}]},{"featureType":"all","elementType":"labels","stylers":[{"lightness":"-60"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"gamma":"5.37"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#419d8c"},{"lightness":"-39"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#e8f6f3"},{"lightness":20}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"saturation":"0"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#42738d"},{"gamma":"5.37"}]}];

		var mapOptions = {
			styles: styles,
			scrollwheel: false,
			zoom: 16,
			// center: new google.maps.LatLng(lat, long),
			zoomControl: true,
			draggable: isDraggable
		};

		var map = new google.maps.Map(document.getElementById('map-canvas'),mapOptions);

		var image = {
			url: template_path + '/dist/images/marker.png',
			scaledSize: new google.maps.Size(75, 75),
			size: new google.maps.Size(150,150),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(36, 75)
		};

		// new google.maps.Marker({
		// 	position: new google.maps.LatLng(lat, long),
		// 	map: map,
		// 	draggable: false,
		// 	icon: image
		// });
		var branch;
		var bounds = new google.maps.LatLngBounds();
		for (var i = 0; i < locations.length; i++) {
			branch = locations[i];
			var myLatLng = new google.maps.LatLng(branch[1], branch[2]);
			var marker = new google.maps.Marker({
				position: myLatLng,
				map: map,
				icon: image,
				title: branch[0],
				zIndex: branch[3]
			});
			bounds.extend(myLatLng);
		}

		// Fit to bounds
		if (locations.length > 1) { map.fitBounds(bounds); }
		else {
			var cp = new google.maps.LatLng(branch[1], branch[2]);
			map.setCenter(cp);
			map.setZoom(14);
		}		
	}
};


var Sage = {
	// All pages
	'common': {
		init: function() {

			jQuery(function($) {

				// Enable if using fixed/css change on scroll (Change class on scroll down)
				$(window).scroll(function() {
					if ($(document).scrollTop() > 20) {
						$(".navbar-fixed-top").addClass("top-nav-collapse");
					} else {
						$(".navbar-fixed-top").removeClass("top-nav-collapse");
					}
				});
				// -----


				// $('.toggle-search').on('click', function(event) {
				// 	event.preventDefault();
				// 	$('.search-nav').toggleClass('open');
				// 	$('.toggle-search').toggleClass('open');
				// });

				$(document).ready(function() { 
					$('.equal-heights').matchHeight();



					// -- Search --
				    $('a[href="#search"]').on('click', function(event) {
				        event.preventDefault();
				        $('#search').addClass('open');
				        $('#search > form > input[type="search"]').focus();
				    });
				    
				    $('#search, #search button.close').on('click keyup', function(event) {
				        if (event.target === this || event.target.className === 'close' || event.keyCode === 27) {
				            $(this).removeClass('open');
				        }
				    });

				    // -- Distortion Social Share --
 					
				    $('.dsshare-link').on('click', function(event) {
				    	var url = $(this).attr("href");
						var popUp = window.open(url, 'popupwindow', 'scrollbars=yes,width=600,height=400');
						popUp.focus();
				        event.preventDefault();
				    });



				});




			});

		},
		finalize: function() {
			// JavaScript to be fired on all pages, after page specific JS is fired
		}
	},

	// Home page
	'home': {
		init: function() {
		// JavaScript to be fired on the home page

		jQuery(function($) {
		  $(document).ready(function(){


			// var feed = new Instafeed({
			// 	get: 'user',
			// 	tagName: 'awesome',
			// 	userId: 3102962946,
			// 	clientId: '0ebdcacf461e44db8fc576cca76250de',
			// 	accessToken: '3102962946.0ebdcac.8666b223158d4147a6c088ce12e94d56',
			// 	sortBy: 'most-recent',
			// 	limit: 4,
			// 	resolution: 'standard_resolution',
		 //        template: '<a href="{{link}}" target="_blank"><img src="{{image}}" /></a>'
			// });

			// feed.run();

			$('.carousel-hero').owlCarousel({
			  loop: true,
			  margin: 0,
			  nav: true,
			  dots: false,
			  autoplay:true,
			  autoplayTimeout:4500,
			  smartSpeed:800,

			  navText: [
				"<i class='fa fa-2x fa-angle-left'></i>",
				"<i class='fa fa-2x fa-angle-right'></i>"
			  ],
			  items: 1
			});

			$('.carousel-posts').owlCarousel({
			  loop: true,
			  nav: false,
			  dots: false,
			  margin: 15,
			  autoplay:true,
			  autoplayTimeout:3500,
			  smartSpeed:800,

			  responsive : {
				0 : {
				  items: 1,
				  slideBy: 1
				},
				480 : {
				  items: 2,
				  slideBy: 1
				},
				768 : {
				  items: 3,
				  slideBy: 1
				},
				992 : {
				  items: 4,
				  slideBy: 1
				}
			  }
			});
		  });
		});
		
	  },
	  finalize: function() {

	  }
	},

	// Sample: Menu fixed
	'sample_menu_fixed': {
		init: function() {
	

		},
		finalize: function() {
			// JavaScript to be fired on all pages, after page specific JS is fired
		}
	},


	'contact': {
	  init: function() {
		jQuery(function($) {

		  $(document).ready(function() { 

		  });

		});

	  }
	}
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				// alert(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
